import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "actions", "onHandleMouseDown", "onDropdownOpenChange", "responsiveSize", "connectDragSource", "isSectionDropdownStep", "isSelectedItem", "isStaticSection", "isEmbed"];
import { memoize } from 'underscore';
import I18n from 'I18n';
import { TrellisHorizontalEdgeToolbar } from 'layout-dnd-components/DndToolbar/HorizontalEdgeToolbar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { updateSelectedItemStyleSectionDropdown, updateSelectedItem
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/selectionActions';
import { cloneSectionFromLayoutSection, requestCloneFromLayoutSection, deleteRowFromLayoutSection
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/moduleActions';
import { openCreateNewSectionPanel
// @ts-expect-error not typed
} from 'ContentEditorUI/redux/actions/inpageActions';
import { SECTION } from 'ContentEditorUI/constants/cloneTypes';
// @ts-expect-error not typed
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
// @ts-expect-error not typed
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
// @ts-expect-error not typed
import { startGeneratedHublRequest } from 'ContentEditorUI/redux/actions/hublActions';
import { hashFunctionForObject } from './helpers';
import { getIsTrellisTheme } from '../../redux/selectors/layoutSectionDndSelectors';
import { useSelector } from 'react-redux';
import { CustomHublIcon } from 'foundations-assets/icons/components/CustomHublIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { DuplicateIcon } from 'foundations-assets/icons/components/DuplicateIcon';
import { EditIcon } from 'foundations-assets/icons/components/EditIcon';
import { EmbedIcon } from 'foundations-assets/icons/components/EmbedIcon';
import { FixedLayoutIcon } from 'foundations-assets/icons/components/FixedLayoutIcon';
import { HideIcon } from 'foundations-assets/icons/components/HideIcon';
import { SaveEditableViewIcon } from 'foundations-assets/icons/components/SaveEditableViewIcon';
import { SectionIcon } from 'foundations-assets/icons/components/SectionIcon';
import { cloneNodeAndInsertAfterOriginalInGridLayout, deleteSectionFromGridLayout } from 'ContentEditorUI/redux/actions/gridsModuleActions';
import { jsx as _jsx } from "react/jsx-runtime";
const buildStyleSectionAction = (sectionName, layoutSectionId, dispatch, bus, {
  isStyleSectionStep,
  onlyInDropdown,
  isEmbed = false
} = {}) => {
  let menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.editStyles"
  });
  let tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.editStyles"
  });
  let trackingType = 'SECTION';
  if (isEmbed) {
    menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.editStyles"
    });
    tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.editStyles"
    });
    trackingType = 'EMBED';
  }
  return {
    id: 'section-styles',
    icon: EditIcon,
    menuLabel,
    tooltipLabel,
    onlyInDropdown,
    callback: () => {
      dispatch(isStyleSectionStep ? updateSelectedItemStyleSectionDropdown(sectionName, layoutSectionId) : updateSelectedItem(sectionName, {
        containerId: layoutSectionId
      }));
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.EDIT_LAYOUT_STYLES, {
        type: trackingType
      }));
    }
  };
};
const buildDuplicateSectionAction = (sectionName, layoutSectionId, dispatch, bus, {
  disableExtraActions,
  onlyInDropdown,
  isEmbed = false
} = {}) => {
  let menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.clone"
  });
  let tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.clone"
  });
  if (isEmbed) {
    menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.clone"
    });
    tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.clone"
    });
  }
  return {
    id: 'section-duplicate',
    icon: DuplicateIcon,
    menuLabel,
    tooltipLabel,
    onlyInDropdown,
    callback: () => {
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.CLONE_ROW, {
        type: isEmbed ? 'EMBED' : undefined
      }));
      dispatch(requestCloneFromLayoutSection(sectionName, layoutSectionId, SECTION, cloneSectionFromLayoutSection(sectionName, layoutSectionId)));
    },
    disabled: disableExtraActions
  };
};
const buildDeleteSectionAction = (sectionName, layoutSectionId, dispatch, bus, {
  disableExtraActions,
  onlyInDropdown,
  isEmbed = false
} = {}) => {
  let menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.delete"
  });
  let tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.delete"
  });
  if (isEmbed) {
    menuLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.delete"
    });
    tooltipLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.embed.delete"
    });
  }
  return {
    id: 'section-delete',
    icon: DeleteIcon,
    menuLabel,
    tooltipLabel,
    onlyInDropdown,
    callback: () => {
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.DELETE_ROW, {
        type: isEmbed ? 'EMBED' : undefined
      }));
      dispatch(deleteRowFromLayoutSection(sectionName, layoutSectionId));
    },
    disabled: disableExtraActions
  };
};
const buildCopyAsHublAction = (sectionName, layoutSectionId, dispatch, bus, {
  disableExtraActions,
  onlyInDropdown
} = {}) => ({
  id: 'copy-as-hubl',
  icon: CustomHublIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.copy"
  }),
  menuTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.copy"
  }),
  onlyInDropdown,
  callback: () => {
    dispatch(startGeneratedHublRequest(sectionName, layoutSectionId));
  },
  disabled: disableExtraActions
});
const buildSectionSaveAction = (sectionName, layoutSectionId, dispatch, bus, {
  disableExtraActions,
  onlyInDropdown,
  isStaticSection
} = {}) => {
  let menuTooltip = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.save"
  });
  if (isStaticSection) {
    menuTooltip = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.fixedLayout.cantSaveDetail"
    });
  }
  return {
    id: 'section-save',
    icon: SaveEditableViewIcon,
    menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.section.save"
    }),
    menuTooltip,
    onlyInDropdown,
    callback: () => {
      dispatch(openCreateNewSectionPanel(sectionName, layoutSectionId));
    },
    disabled: disableExtraActions || isStaticSection
  };
};
const buildHideOnMobileAction = (bus, toggleNodeVisibilityOnThisBreakpoint) => ({
  id: 'section-hide',
  icon: HideIcon,
  menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.hide"
  }),
  tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "inpage.actionToolbar.section.hide"
  }),
  callback: e => {
    if (e) {
      toggleNodeVisibilityOnThisBreakpoint(false, e);
      bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.HIDE_SECTION));
    }
  }
});
const buildGridToolbarActions = (bus, id, gridLayoutId, isInDefaultBreakpointMode, toggleNodeVisibilityOnThisBreakpoint, dispatch) => {
  const actions = [{
    id: 'section-styles',
    icon: EditIcon,
    menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.section.editStyles"
    }),
    tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "inpage.actionToolbar.section.editStyles"
    }),
    placement: 'top left',
    callback: () => {
      if (id) {
        dispatch(updateSelectedItem(id, {
          containerId: gridLayoutId
        }));
      }
    }
  }];
  if (isInDefaultBreakpointMode) {
    actions.push({
      id: 'section-duplicate',
      icon: DuplicateIcon,
      menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.section.clone"
      }),
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.section.clone"
      }),
      callback: () => {
        if (id) {
          dispatch(cloneNodeAndInsertAfterOriginalInGridLayout(gridLayoutId, id));
        }
      },
      placement: 'top left'
    }, {
      id: 'section-delete',
      icon: DeleteIcon,
      menuLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.section.delete"
      }),
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "inpage.actionToolbar.section.delete"
      }),
      callback: () => {
        if (id) {
          dispatch(deleteSectionFromGridLayout(gridLayoutId, id));
        }
      },
      placement: 'top left'
    });
  } else {
    actions.push(buildHideOnMobileAction(bus, toggleNodeVisibilityOnThisBreakpoint));
  }
  return actions;
};
export const buildActionsForSection = memoize(({
  sectionName,
  layoutSectionId,
  gridLayoutId,
  isInDefaultBreakpointMode,
  disableExtraActions,
  isStyleSectionStep,
  dispatch,
  bus,
  shouldUseCustomSections,
  isInDeveloperMode,
  toggleNodeVisibilityOnThisBreakpoint,
  isEmbed,
  isStaticSection
}) => {
  if (gridLayoutId) {
    return buildGridToolbarActions(bus, sectionName, gridLayoutId, isInDefaultBreakpointMode, toggleNodeVisibilityOnThisBreakpoint, dispatch);
  }
  const actions = [buildStyleSectionAction(sectionName, layoutSectionId, dispatch, bus, {
    isStyleSectionStep,
    onlyInDropdown: false,
    isEmbed
  })];
  if (isInDefaultBreakpointMode) {
    actions.push(buildDuplicateSectionAction(sectionName, layoutSectionId, dispatch, bus, {
      disableExtraActions,
      onlyInDropdown: false,
      isEmbed
    }), buildDeleteSectionAction(sectionName, layoutSectionId, dispatch, bus, {
      disableExtraActions,
      onlyInDropdown: false,
      isEmbed
    }));
    if (shouldUseCustomSections && !isEmbed) {
      actions.push(buildSectionSaveAction(sectionName, layoutSectionId, dispatch, bus, {
        disableExtraActions,
        onlyInDropdown: true,
        isStaticSection
      }));
    }
    if (isInDeveloperMode && !isEmbed) {
      actions.push(buildCopyAsHublAction(sectionName, layoutSectionId, dispatch, bus, {
        disableExtraActions,
        onlyInDropdown: true
      }));
    }
  } else {
    actions.push(buildHideOnMobileAction(bus, toggleNodeVisibilityOnThisBreakpoint));
  }
  return actions;
}, hashFunctionForObject);
export const BaseResponsiveSectionToolbar = _ref => {
  let {
      active,
      actions,
      onHandleMouseDown,
      onDropdownOpenChange,
      responsiveSize,
      connectDragSource,
      isSectionDropdownStep,
      isSelectedItem,
      isStaticSection,
      isEmbed
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTrellisTheme = useSelector(getIsTrellisTheme);
  const buttonActions = [...actions];
  const styleActionIndex = buttonActions.findIndex(action => action.id === 'section-styles');
  const styleActionCallback = buttonActions[styleActionIndex] ? buttonActions[styleActionIndex].callback : () => {};

  // Assume style action button's callback should be used when clicking on the "icon" of this toolbar
  const iconClickHandler = styleActionIndex === -1 || buttonActions[styleActionIndex].disabled || isSectionDropdownStep ? undefined : styleActionCallback;
  if (isSelectedItem && styleActionIndex !== -1) {
    buttonActions.splice(styleActionIndex, 1);
  }
  let handleTooltip = I18n.text('inpage.actionToolbar.section.label');
  let icon = SectionIcon;
  if (isEmbed) {
    handleTooltip = I18n.text('inpage.actionToolbar.embed.label');
    icon = EmbedIcon;
  } else if (isStaticSection) {
    handleTooltip = I18n.text('inpage.actionToolbar.fixedLayout.label');
    icon = FixedLayoutIcon;
  }
  return /*#__PURE__*/_jsx(TrellisHorizontalEdgeToolbar, Object.assign({}, props, {
    "data-test-id": "hs-ls-responsive-section-toolbar",
    position: "absolute",
    zIndex: 3,
    active: active,
    icon: icon,
    actions: buttonActions,
    responsiveSize: responsiveSize,
    onHandleMouseDown: onHandleMouseDown,
    onDropdownOpenChange: onDropdownOpenChange,
    onHandleClick: iconClickHandler,
    handleButtonRef: handleButtonElement => {
      if (handleButtonElement && connectDragSource) {
        connectDragSource(handleButtonElement);
      }
    },
    handleTooltip: handleTooltip,
    handleTooltipPlacement: "top right",
    handleButtonStyles: {
      cursor: 'move',
      borderWidth: '100'
    },
    draggable: true,
    variant: !isEmbed ? 'primary' : 'accentPurple',
    isTrellisTheme: isTrellisTheme
  }));
};